import React from "react";
import { motion } from "framer-motion";
import { TransformButton } from "./TransformButton";
const PAINS = [{
  emoji: "😰",
  text: "Tienes un paciente con desgaste severo y no sabes exactamente por dónde comenzar."
}, {
  emoji: "⏱️",
  text: "Inviertes demasiado tiempo revisando apuntes antes de planificar una rehabilitación."
}, {
  emoji: "🤷",
  text: "Aún dudas cuando debes decidir si modificar la DVO."
}, {
  emoji: "💸",
  text: "Sabes que podrías aceptar tratamientos de mayor valor, pero la inseguridad te detiene."
}, {
  emoji: "😓",
  text: "Has tenido retrabajos que pudieron evitarse con una mejor planificación."
}, {
  emoji: "😩",
  text: "Antes de iniciar un caso complejo, sientes más incertidumbre que confianza."
}];
export function PainPoints() {
  return <section className="w-full bg-white px-4 py-14" data-id="element-191" data-mp="3idun2hl9vvfn">
      <div className="mx-auto max-w-2xl text-center" data-id="element-192" data-mp="3ie4dg6a8c4lv">
        <h2 className="font-serif-display text-2xl font-extrabold text-gray-900 sm:text-3xl" data-id="element-193" data-mp="3nd7ktxdommx0">
          👉 ¿Te identificas con alguna de estas situaciones?
        </h2>
        <p className="mt-3 text-sm text-gray-600 sm:text-base" data-id="element-194" data-mp="1yyc0xmejc4q1">
          Si respondes <strong className="text-[var(--brand)]" data-id="element-195" data-mp="1u1bu399v2xxv">SÍ</strong> a alguna… este sistema fue creado para ti.
        </p>

        <div className="mt-8 space-y-3 text-left" data-id="element-196" data-mp="27v32gebuwbs0">
          {PAINS.map((p, i) => <motion.div key={p.text} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="flex items-start gap-3 rounded-xl border border-gray-100 bg-[var(--cream)] p-4" data-id="element-197" data-mp="23s6rn9sk5jym" data-mpi={i}>
              <span className="text-2xl leading-none" data-id="element-198" data-mp="1k2wbjuowgwzz">{p.emoji}</span>
              <p className="text-sm text-gray-700 sm:text-base" data-id="element-199" data-mp="30hnvrkbw6xy7">{p.text}</p>
            </motion.div>)}
        </div>

        <div className="mt-8 rounded-2xl bg-[var(--brand)] p-6 text-white" data-id="element-200" data-mp="2vj2vjkwn4e9r">
          <p className="text-base font-semibold sm:text-lg" data-id="element-201" data-mp="1t559y6h0otvf">Y no debería ser así.</p>
          <p className="mt-2 text-sm text-white/80 sm:text-base" data-id="element-202" data-mp="1t7hpye37su5u">
            Porque el problema no es tu experiencia. El problema es que nunca te enseñaron un
            sistema para tomar decisiones clínicas de forma estructurada.
          </p>
        </div>

        <TransformButton label="Quiero un sistema estructurado" data-id="element-203" data-mp="273mw3zr9xyb8" />
      </div>
    </section>;
}